export default [
    {
        path: '/bailes',
        name: 'bailes',
        component: () => import(/* webpackChunkName: "home" */ './Bailes')
    }
]
